import { useEffect, useRef } from 'react';

import { mountMathExplainer } from './mathDemos';

// Thin React wrapper: mounts the framework-agnostic math explainer (prose,
// formulas, and interactive canvas demos) into a div and tears it down on
// unmount. All demo logic lives in mathDemos.js so the standalone HTML and the
// /lab page render the exact same explainer.
function MathExplainer() {
  const ref = useRef(null);

  useEffect(() => {
    const cleanup = mountMathExplainer(ref.current);
    return cleanup;
  }, []);

  return <div ref={ref} />;
}

export default MathExplainer;
